<template>
    <div class="mc-tag" :class="dynamicClasses">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        appearance: {
            type: String,
            default: '',
            validator(value) {
                return ['', 'active', 'highlight', 'inactive', 'disabled', 'removed'].includes(value);
            },
        },
    },
    computed: {
        dynamicClasses() {
            return {
                [`mc-tag--${this.appearance}`]: this.appearance !== 'default',
            };
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.mc-tag {
    background: $cream-white;
    color: $primary-text-color;
    width: fit-content;
    height: fit-content;
    padding: 5px;
    border-radius: $default-border-radius;
    font-size: 13px;
    line-height: 16px;

    &--active {
        background: $tertiary;
    }

    &--highlight {
        background: $primary;
        color: $white;
    }

    &--inactive {
        background: $bright-blue;
    }

    &--disabled {
        background: $cream-white;
        color: $darkest-gray;
    }

    &--removed {
        background: $cream-white-dark;
    }
}
</style>
